import { ApprovalRuleResponse } from 'src/models/organizations.models'
import { orgQueryKeys } from 'src/queries/queries.constants'
import {
  ExtendBaseQueryOptions,
  useExtendQuery,
} from 'src/queries/queries.utils'

interface QueryOrgApprovalRulesOptions
  extends ExtendBaseQueryOptions<
    { approvalRules: ApprovalRuleResponse[] },
    ApprovalRuleResponse
  > {
  orgId: string | undefined
}

export const useQueryOrgApprovalRules = ({
  orgId,
  enabled = true,
  ...rest
}: QueryOrgApprovalRulesOptions) => {
  return useExtendQuery({
    queryKey: orgQueryKeys.approvalRules(orgId),
    queryUrl: () => `/organizations/${orgId}/approvalrules`,
    enabled: enabled && orgId !== undefined,
    select: (data): ApprovalRuleResponse => {
      // TODO not sure why this is an array - may need to reformat this later if new rules are added
      return data.approvalRules[0]
    },
    ...rest,
  })
}
